export default __webpack_public_path__ + "imgs/xiaohongshu_code.a9ef913e.png";